import { currentRefinements as algoliaCurrentRefinements } from 'instantsearch.js/es/widgets';

const transformLabel = ({ label }) => {
  switch (label) {
    case 'presence':
      return 'Presence';
    case 'skills':
      return 'Skills';
    case 'duration_kind':
      return 'Duration';
    case '_tags':
      return 'Issue area';
    default:
      return label;
  }
};

const transformItems = (items) => {
  return items.map((item) => ({
    ...item,
    label: transformLabel(item),
  }));
};

export const currentRefinements = ({ container }) =>
  algoliaCurrentRefinements({
    container: container,
    includedAttributes: ['query', 'presence', 'aroundRadius', '_tags', 'skills', 'duration_kind'],
    cssClasses: {
      root: '',
      category: 'pr-2',
      label: 'pr-1',
      list: ['flex', 'flex-row', 'flex-wrap', '-m-1'],
      item: [
        'm-1',
        'pl-3',
        'pr-1',
        'py-0.5',
        `bg-primary-100`,
        'text-sm',
        'font-medium',
        `text-primary-700`,
        'rounded-full',
      ],
      delete: [
        '-mr-0.5',
        'ml-1.5',
        `text-primary-700`,
        'focus:outline-none',
        `hover:text-primary-500`,
        `focus:text-primary-500`,
      ],
    },
    transformItems,
  });
